import { render, staticRenderFns } from "./law.vue?vue&type=template&id=0c7c7eec&scoped=true"
import script from "./law.vue?vue&type=script&lang=js"
export * from "./law.vue?vue&type=script&lang=js"
import style0 from "./law.vue?vue&type=style&index=0&id=0c7c7eec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c7c7eec",
  null
  
)

export default component.exports